import { el } from 'https://cdn.venturz.co/lib/redom.es.js';

const showMoreLabel = 'Show more';
const retryLabel = 'Retry';

class ShowMoreControl {

  constructor(onLoadMore) {

    this.onLoadMore = onLoadMore;
    this.loading = false;

    this.spinner = el('ht-spinner.directory-show-more__spinner', { size: 'small' });
    this.spinner.setAttribute('aria-hidden', 'true');

    this.label = el('span.directory-show-more__label', showMoreLabel);

    this.button = el('button.directory-show-more__button', [this.spinner, this.label]);
    this.button.setAttribute('type', 'button');

    this.status = el('p.directory-show-more__status');
    this.status.setAttribute('role', 'status');
    this.status.setAttribute('aria-live', 'polite');

    this.el = el('div.directory-show-more', [this.button, this.status]);

    this.handleClick = this.handleClick.bind(this);
    this.button.addEventListener('click', this.handleClick);

  }

  async handleClick() {

    if (this.loading === true) {
      return;
    }

    await this.onLoadMore();

  }

  startLoading() {

    this.loading = true;
    this.button.setAttribute('disabled', '');
    this.button.setAttribute('aria-busy', 'true');
    this.el.classList.add('directory-show-more--loading');

  }

  stopLoading(loadedCount) {

    this.loading = false;
    this.button.removeAttribute('disabled');
    this.button.removeAttribute('aria-busy');
    this.el.classList.remove('directory-show-more--loading');
    this.label.textContent = showMoreLabel;
    this.setLoadedStatus(loadedCount);

  }

  markComplete(loadedCount) {

    this.loading = false;
    this.el.classList.remove('directory-show-more--loading');
    this.el.classList.add('directory-show-more--complete');
    this.button.removeAttribute('aria-busy');
    this.setStatus(`You're all caught up — ${formatCount(loadedCount)} loaded`);

  }

  showError() {

    this.loading = false;
    this.button.removeAttribute('disabled');
    this.button.removeAttribute('aria-busy');
    this.el.classList.remove('directory-show-more--loading');
    this.label.textContent = retryLabel;
    this.setStatus('Couldn\'t load more records. Please try again.');

  }

  setLoadedStatus(loadedCount) {

    this.setStatus(`Showing ${formatCount(loadedCount)}`);

  }

  setStatus(text) {

    this.status.textContent = text;

  }

}

function formatCount(count) {

  const suffix = count === 1 ? '' : 's';

  return `${count} record${suffix}`;

}

export default ShowMoreControl;
